import { Tabs, styled } from '@mui/material'

interface StyledTabsProps {
  id?: string
  children?: React.ReactNode
  variant?: 'standard' | 'scrollable' | 'fullWidth' | undefined
  value: number
  onChange: (event: React.SyntheticEvent, newValue: number) => void
  'aria-label': string
}

export const StyledTabs = styled((props: StyledTabsProps) => <Tabs indicatorColor="secondary" textColor="primary" {...props} />)(
  ({ theme }) => ({
    '& .MuiTab-root': {
      border: '0px solid',
      borderBottom: `2px solid ${theme.palette.grey[200]}`,
      color: theme.palette.grey[400],
      height: '40px',
      minHeight: 'auto',
      marginTop: 8,
      fontWeight: 500
    },
    '& .Mui-selected': {
      borderBottom: `2px solid ${theme.palette.secondary.main}`,
      color: theme.palette.secondary.main,
      border: '0px solid'
    },
    '& .MuiTabs-indicator': {
      display: 'none'
    },
    '& .MuiTabs-root': {
      marginBottom: '16px'
    }
  })
)
